import { AbstractDialogContent } from '@abstracts/dialog/dialog-content';
import { Component, Injector, Input, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { PatchChargingStationAllowedUsers } from '@dto/httpPatch/patchChargingStationAllowedUsers';
import { UserForRfidAuth } from '@dto/userForRfidAuth';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ChargingStationsService } from '@services/entity/charging-stations.service';
import { UsersService } from '@services/entity/users.service';
import { FormService } from '@services/form/form.service';
import { RouteDataService } from '@services/route-data/route-data.service';
import { ToastService } from '@services/toast/toast.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { DEDatePipe } from 'src/app/pipes/de-date.pipe';
import { ChargingStationAuthorizationResponse } from '../../../../models/ChargingStationAuthorizationResponse';
import { isEqual } from 'lodash-es'
import { AbstractEditEntityComponent } from '@abstracts/entities/edit-entity';
import { IEntity } from '@interfaces/entity';
import { ChargingStation } from '@models/charging-station';
import { plainToClass } from 'class-transformer';

@Component({
  selector: 'app-charging-station-rfid-auth',
  templateUrl: './charging-station-rfid-auth.component.html',
  styleUrls: ['./charging-station-rfid-auth.component.scss'],
})
export class ChargingStationRfidAuthComponent extends AbstractEditEntityComponent implements OnInit {
  public entity: ChargingStation;
  public isSupporter: boolean = false;

  initializeEntity(entity: any) {
    this.entity = plainToClass(ChargingStation, entity);
    this.loadAllowedUsers();
    this.initializeUsers();
    this.loadResponse();
  }

  public className = 'ChargingStationRfidAuthComponent';
  spinner1 = 'editSpinner';

  private customerId: number;
  @Input() isOperator: boolean = false;


  public allUsers: UserForRfidAuth[];

  public allowedUsers: UserForRfidAuth[];

  public formReady: boolean = false;

  public ChargingStationAuthorizationResponse: ChargingStationAuthorizationResponse;

  constructor(
    private chargingStationsService: ChargingStationsService,
    private toastService: ToastService,
    private spinner: NgxSpinnerService,
    private usersService: UsersService,
    public injector: Injector) {
    super(chargingStationsService, injector);
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.isSupporter = this.authenticationService.userHasRole('Supporter')

  }

  loadAllowedUsers() {
    if (!this.primaryKey) {
      this.primaryKey = this.routeDataService.params.key;
    }

    this.chargingStationsService.getAllowedUsersAsync(this.primaryKey).subscribe(result => {
      this.allowedUsers = result
      this.allowedUsers = this.allowedUsers.sort((a, b) => a.fullName.localeCompare(b.fullName))
      this.createForm()
    });

  }

  loadResponse() {
    var datePipe = new DEDatePipe();
    this.chargingStationsService.getChargingStationAuthorizationResponse(this.primaryKey.toString()).subscribe(response => {
      this.ChargingStationAuthorizationResponse = response;
      if (response != null)
        this.ChargingStationAuthorizationResponse.updatedAt = datePipe.transform(response.updatedAt);
    }, error => {
      this.toastService.error('Status des letzten Autorisierungsversuchs konnte nicht geladen werden!')
    });
  }

  initializeUsers() {
      this.loadUsers(this.entity.customerId)
    }

  loadUsers(customerId: number) {
    if (this.isOperator) {
      this.usersService.getUsersOfCustomerForRfidAuth(customerId).subscribe(result => {
        this.allUsers = result;
        this.allUsers = this.allUsers.sort((a, b) => a.fullName.localeCompare(b.fullName))
      }, error => { });
    } else {
      this.usersService.getUsersForRfidAuth().subscribe(result => {
        this.allUsers = result;
        this.allUsers = this.allUsers.sort((a, b) => a.fullName.localeCompare(b.fullName))
      }, error => { });
    }
  }

  getAdditionalEntities() {
  }

  clear(item: any): void {
    const control = this.formService.form.get('selectedAllowedUsers');

    if (!control) {
      return;
    }

    const currentValues = control.value || [];

    const updatedValues = currentValues.filter((u: any) => u.id !== item.id);

    control.setValue(updatedValues);
    control.markAsDirty();
    control.markAsTouched();
  }

  createForm() {
    this.formService.form = new UntypedFormGroup({
      selectedAllowedUsers: new UntypedFormControl(this.allowedUsers),
    });
    // this.formService.form.get('selectedAllowedUsers').markAsDirty();
    if (this.isSupporter) this.formService.form.disable()
    this.formReady = true;
  }

  compareFn(item, selected) {
    return item.id === selected.id
  }

  //customSearch(term: string, item) {
  //  term = term.toLocaleLowerCase();
  //  if(item['email']!=null)
  //    return item['fullName'].toLocaleLowerCase().indexOf(term) > -1 || item['email'].toLocaleLowerCase().indexOf(term) > -1;
  //  else
  //    return item['fullName'].toLocaleLowerCase().indexOf(term) > -1;

  //}

  customSearchFn = (term: string, item: any): boolean => {
    const selectedUsers = this.formService.form.get('selectedAllowedUsers')?.value || [];
    const alreadySelected = selectedUsers.some((u: any) => u.id === item.id);
    if (alreadySelected) {
      return false;
    }


    const search = term.toLowerCase();

    return (
      item.fullName?.toLowerCase().includes(search) ||
      item.email?.toLowerCase().includes(search)
    );
  };

  onSearch(item) {
    console.log(item);
    console.log('search called' + item.term);
  }


  onSubmit(formValue) {
    const patch: PatchChargingStationAllowedUsers = {
      userIds: formValue.selectedAllowedUsers.map(user => user.id)
    };
    this.spinner.show(this.spinner1);
    this.chargingStationsService.patchEntityWithEndpoint(this.primaryKey, 'allowedUsers', patch).subscribe(result => {
      this.toastService.success('Autorisierung erfolgreich gespeichert.');
      this.loadResponse()
      this.spinner.hide(this.spinner1);
    }, error => {
      this.toastService.error('Autorisierung konnte nicht gespeichert werden.')
      this.spinner.hide(this.spinner1);
    });
  }
  synchronWhitelistNow() {
    this.spinner.show(this.spinner1);
    this.chargingStationsService.updateChargingStationWhitelist(this.primaryKey.toString()).subscribe(result => {
      this.toastService.success('Autorisierungsanfrage wurde erfolgreich gesendet.');
      this.loadResponse()
      this.spinner.hide(this.spinner1);
    }, error => {
      this.toastService.error('Autorisierung fehlgeschlagen.')
      this.spinner.hide(this.spinner1);
    });
  }
}
